// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/firestore'
import Rates from './class/Rates'

// prd
const config = {
  apiKey: 'AIzaSyAwZLmdir5oGGbCGEuJiDu1UfT4ZRfQjq8',
  authDomain: 'keyakizaka-porintsite-dev.firebaseapp.com',
  databaseURL: 'https://keyakizaka-porintsite-dev.firebaseio.com',
  projectId: 'keyakizaka-porintsite-dev',
  storageBucket: 'keyakizaka-porintsite-dev.appspot.com',
  messagingSenderId: '73339397361'
}

// dev
// const config = {
//   apiKey: 'AIzaSyDE1LhCygzJEo7MFNXkUAqkGMf8ULQwhLw',
//   authDomain: 'keyakizaka-pointsite-dev.firebaseapp.com',
//   databaseURL: 'https://keyakizaka-pointsite-dev.firebaseio.com',
//   projectId: 'keyakizaka-pointsite-dev',
//   storageBucket: 'keyakizaka-pointsite-dev.appspot.com',
//   messagingSenderId: '596537016490'
// }
firebase.initializeApp(config)

Rates.setFirebase(firebase)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js